// Seletores do acesso às carteiras (walletAccess).

export const WALLET_ACCESS_AREAS = [
  'balance',
  'extract',
  'charges',
  'anticipations',
  'invoices',
  'notifications',
  'fees',
];

// uid da carteira em uso: a selecionada pela secretária ou a do próprio usuário
export const getWalletOwnerId = (state) => state.Asaas.walletOwnerId || state.Auth.user?.uid;

// Config normalizada do que o usuário vê numa carteira. Dono → tudo liberado;
// secretária → entry do walletAccess; sem concessão → null.
export function getWalletAccessConfig(account, viewerUid, walletOwnerUid) {
  if (!viewerUid) return null;
  if (viewerUid === walletOwnerUid) {
    const full = {};
    WALLET_ACCESS_AREAS.forEach((area) => {
      full[area] = true;
    });
    return full;
  }
  const entry = account?.walletAccess?.[viewerUid];
  if (!entry || entry.enabled !== true) return null;
  const config = {};
  WALLET_ACCESS_AREAS.forEach((area) => {
    config[area] = entry[area] === true;
  });
  return config;
}

// Carteiras ativas e aprovadas que uma secretária pode abrir
export function getAccessibleWalletIds(accounts, viewerUid) {
  if (!accounts || !viewerUid) return [];
  return Object.keys(accounts).filter((ownerUid) => {
    const account = accounts[ownerUid];
    return !!account
      && account.active
      && !!account.subaccountId
      && account.kycStatus === 'APPROVED'
      && account.walletAccess?.[viewerUid]?.enabled === true;
  });
}
